import { Component } from '@angular/core';

@Component({
  selector: 'ocado-un-authorized',
  standalone: true,
  imports: [],
  templateUrl: './un-authorized.component.html',
  styleUrl: './un-authorized.component.scss'
})
export class UnAuthorizedComponent {

}
